import React, { useMemo } from "react";

export default function CourierActivity({ routes = [] }) {
  const couriers = useMemo(() => {
    const map = new Map();
    routes.forEach((r) => {
      if (!r.driver) return;
      const lastUpdate =
        r.receipts?.reduce((latest, rec) => {
          const t = rec.status_changed_at ? new Date(rec.status_changed_at) : null;
          return !latest || (t && t > latest) ? t : latest;
        }, null) || null;
      map.set(r.driver, {
        driver: r.driver,
        route_number: r.route_number,
        route_status: r.route_status,
        lastUpdate,
      });
    });
    return Array.from(map.values());
  }, [routes]);

  return (
    <div
      style={{
        background: "#fff",
        borderRadius: 12,
        padding: 16,
        boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
      }}
    >
      <h3 style={{ marginTop: 0 }}>Активность курьеров</h3>
      <p style={{ color: "#666", marginBottom: 8 }}>
        Последние обновления маршрутов по водителям.
      </p>

      {couriers.length === 0 ? (
        <p style={{ color: "#999" }}>Нет данных за выбранный период.</p>
      ) : (
        <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
          {couriers.map((c) => (
            <li
              key={c.driver}
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "6px 0",
                borderBottom: "1px solid #f3f3f3",
                fontSize: 14,
              }}
            >
              <span>
                🚚 {c.driver}{" "}
                <small style={{ color: "#666" }}>
                  (№{c.route_number}, {c.route_status})
                </small>
              </span>
              <span style={{ color: "#333" }}>
                {c.lastUpdate
                  ? new Date(c.lastUpdate).toLocaleTimeString("ru-RU", {
                      hour: "2-digit",
                      minute: "2-digit",
                      second: "2-digit",
                    })
                  : "—"}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
